import React from "react";
import {
  Datagrid,
  TextField,
  ReferenceField,
  Show,
  TabbedShowLayout,
  Tab,
  DateField,
  ArrayField
} from "react-admin";

var constants = require("../moduleConstants");
const ADMINUI_URL = constants.ADMINUI_URL;

const setCurrentEvent = ({ record }) => {
  localStorage.setItem("workingEventId", record.id);
  localStorage.setItem("workingEventName", record.name);
};

const ContactsViewLink = ({ record }) => {
  setCurrentEvent({ record });
  var link = `${ADMINUI_URL}/#/contactsInEvent?filter=%7B%22organizationId%22%3A%22${
    record.id
  }%22%7D`;
  return (
    <p>
      För att lägga till, ändra eller ta bort kontakter, klicka{" "}
      <a href={link}>här</a>
    </p>
  );
};

const EventTitle = ({ record }) => {
  return <span>Event {record ? `"${record.name}"` : ""}</span>;
};

export const EventShow = props => (
  <Show title={<EventTitle />} {...props}>
    <TabbedShowLayout>
      <Tab label="events.show.tabGeneral">
        <TextField source="id" />
        <TextField source="name" />
        <DateField source="startDate" />
        <DateField source="endDate" />
        <ReferenceField
          source="groupId"
          reference="groups"
          linkType="show"
          allowEmpty
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField
          source="responsibleUserId"
          reference="users"
          linkType="show"
          allowEmpty
        >
          <TextField source="name" />
        </ReferenceField>
      </Tab>
      <Tab label="events.show.tabUsers">
        <ArrayField source="usersinGroup">
          <Datagrid>
            <ReferenceField
              label="users.show.name"
              source="userId"
              reference="users"
              linkType="show"
            >
              <TextField source="name" />
            </ReferenceField>
            <TextField source="role" />
          </Datagrid>
        </ArrayField>
      </Tab>
      <Tab label="events.show.tabContacts">
        <ContactsViewLink />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
